var App = App || {};

App.ChatLaunch = (function ($) {
    'use strict';

    function init() {
        $("a[href='#LiveChat']").on("click", function () {
            $("#LP_DIV_1602863147694 > div").click();
        });
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.ChatLaunch.init();
});